import { FC } from "react";

import {
    InsightsTeam,
    InsightsIndividual,
} from "store/api/investorCompany/interfaces";
import InsightStatus from "../InsightStatus";
import { GaugeChart } from "components/ui/GaugeChart";
import Title from "routes/company/components/Modal/Title";
import IndividualScores from "routes/company/components/IndividualScores";
import InsightDescription from "routes/company/components/Modal/InsightDescription";

type Props = {
    tooltip: string;
    teamData: InsightsTeam;
    individualData: InsightsIndividual;
};

const StrategicConsensusModal: FC<Props> = ({
    tooltip,
    individualData,
    teamData: { td_strategic_consensus },
}: Props) => {
    const tdStrategicConsensusValue =
        (td_strategic_consensus?.value as number) ?? 0;

    return (
        <div className="flex flex-col gap-4">
            <Title tooltip={tooltip}>Strategic consensus</Title>

            <div className="flex justify-center">
                <GaugeChart value={tdStrategicConsensusValue} />
            </div>

            <div>
                <InsightStatus value={tdStrategicConsensusValue} />

                <InsightDescription>
                    {td_strategic_consensus?.conclusion?.text ?? ""}
                </InsightDescription>
            </div>

            <IndividualScores
                individualData={individualData}
                teamMetricValue={tdStrategicConsensusValue}
                metric="td_strategic_consensus"
            />
        </div>
    );
};

export default StrategicConsensusModal;
